// Delete file when cleaning up deliveroo_compal_a11y_fixes

import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	issueIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueIconAltTextGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issueIconAltText: {
		id: 'command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text',
		defaultMessage: 'Icon for the project {name}',
		description: 'Alternate text for the icon displayed next to the project',
	},
	issueIconAltTextGalaxia: {
		id: 'command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text-galaxia',
		defaultMessage: 'Icon for the space {name}',
		description: 'Alternate text for the icon displayed next to the project',
	},
});
